initialEntries